module.exports = __webpack_public_path__ + "media/icons/review_badge-607440b0.png";